// src/components/WeekSelector/WeekSelector.js
import React, { useMemo } from 'react';
import moment from 'moment';
import 'moment/locale/es';
import { useI18n, useTranslation } from '../../i18n';

const WeekSelector = ({ selectedWeek, setSelectedWeek }) => {
  const { t } = useTranslation();
  const { language } = useI18n();

  moment.locale(language === 'en' ? 'en' : 'es');

  // siempre trabajamos con el lunes ISO como “ancla”
  const weekStart = useMemo(
    () => moment(selectedWeek || moment()).startOf('isoWeek'),
    [selectedWeek]
  );
  const weekEnd = useMemo(() => weekStart.clone().endOf('isoWeek'), [weekStart]);

  const label = `${weekStart.format('DD/MM/YYYY')} - ${weekEnd.format('DD/MM/YYYY')}`;

  const goPrev = () => setSelectedWeek(weekStart.clone().subtract(1, 'week'));
  const goNext = () => setSelectedWeek(weekStart.clone().add(1, 'week'));
  const goToday = () => setSelectedWeek(moment().startOf('isoWeek'));

  // input type="date" devuelve YYYY-MM-DD. Nosotros lo convertimos a “lunes ISO”
  const handleChange = (e) => {
    const raw = e.target.value; // "YYYY-MM-DD"
    const m = moment(raw, 'YYYY-MM-DD', true);
    if (!m.isValid()) return;
    setSelectedWeek(m.startOf('isoWeek'));
  };

  return (
    <div className="week-selector-container" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <button type="button" className="btn btn-outline-secondary btn-sm" onClick={goPrev}>
        ◀
      </button>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <label htmlFor="week-select" style={{ margin: 0 }}>
          {t('weekSelector.week')}
        </label>
        <div style={{ fontWeight: 700 }}>{label}</div>
      </div>

      <button type="button" className="btn btn-outline-secondary btn-sm" onClick={goNext}>
        ▶
      </button>

      <div style={{ marginLeft: 'auto', display: 'flex', flexDirection: 'column', gap: 4, minWidth: 210 }}>
        <small style={{ opacity: 0.75 }}>{t('weekSelector.selectDate')}</small>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input
            id="week-select"
            type="date"
            value={weekStart.format('YYYY-MM-DD')}
            onChange={handleChange}
            className="form-control"
          />
          <button type="button" className="btn btn-outline-primary btn-sm" onClick={goToday}>
            {t('weekSelector.today')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WeekSelector;